import store from "../redux/store";

export function authHeader() {
    // return authorization header with jwt token
    let user = store.reduxStore.getState().user;
    if (user && user.jwt) {
        return { 'Authorization': 'Bearer ' + user.jwt };
    } else {
        return {};
    }
}